var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.158 0V24.4446L0 21.8715V2.57312L23.158 0ZM20.5849 13.5076L11.579 13.5089V20.5682L20.5849 21.5691V13.5089V13.5076ZM2.57312 19.5673L9.00591 20.2826V13.5089L2.57312 13.5076V19.5673ZM20.5849 10.9357V2.87546L11.579 3.87511V10.9357L20.5849 10.9345V10.9357ZM9.00591 4.16202L2.57312 4.87606V10.9357H9.00591V4.16073V4.16202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.fa4798075f00dd2b9d55307bd190d795.svg";
export { ForwardRef as ReactComponent };